"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compare = compare;
exports.compareProps = compareProps;
exports.comparePropsFn = comparePropsFn;
function compare(a, b, desc = false) {
    const sign = desc ? -1 : 1;
    return sign * (a < b ? -1 : a > b ? 1 : 0);
}
function compareProps(a, b, props, desc = false) {
    props = Array.isArray(props) ? props : [props];
    let result = 0;
    while (!result && props.length) {
        const p = props.shift();
        result = compare(a[p], b[p], desc);
    }
    return result;
}
function comparePropsFn(props, desc = false) {
    return (a, b) => compareProps(a, b, props, desc);
}
//# sourceMappingURL=compare.util.js.map